import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
// import { Loading } from 'element-ui'
import store from '@/store'
import { starLoading, closeLoading, getCurrentLoading } from '@/utils/loading.js'

import { getToken } from '@/utils/auth'
import { getApiHostForTest } from '@/utils/utilsOnlyForPC'
const configs = require('@/_app/' + process.env.PROJECT + '/src/config/index.js').default
// 加解密文件
import { encryptData, decryptData } from '../../static/encryption.js'
let Loadings = getCurrentLoading()
let NoLoading = false // 是否启用loading
let TargetLoadingDom = '.app-main-loading' // 是否启用loading
let HasErrorMessage = false // 是否启用错误提示
let flag=false;
const whiteList = ['/plugin.servlet?type=350', '/plugin.servlet?type=399','/plugin.servlet?type=137','/plugin.servlet?type=131'];
const CloseLoading =(data)=>{
  // Loadings = getCurrentLoading()
  // if(Loadings && Loadings.close) {
  //   Loadings.close()
  // }
  // console.error(data)
  closeLoading()
  HasErrorMessage = false
  NoLoading = false
  Loadings = null
  TargetLoadingDom = '.app-main'
}
let baseUrl = getApiHostForTest() || process.env.BASE_API
if(baseUrl && baseUrl.indexOf('http') == -1){ //
  baseUrl = window.location.protocol +'//' +window.location.host + baseUrl
}
// create an axios instance
const service = axios.create({
  baseURL: baseUrl, // api的base_url\
  // baseURL:'http://172.18.3.55:1500',
  timeout: 1000000, // request timeout
  responseType: 'json',
  withCredentials: configs.withCredentials, // 是否允许带cookie这些
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
    // 'SpecifiedServerIp': '192.168.1.115'
  }
})
// request interceptor
service.interceptors.request.use(config => {
  // Do something before request is sent
  if (!config.headers.token && store.getters.token && configs.hasToken) {
    config.headers['Token'] = getToken() // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  }
  if(config.data && config.data.noLoading){  // 是否启用loading
    NoLoading = config.data.noLoading
    delete config.data.noLoading;
  }else{
    NoLoading = false
  }
  if(config.data && config.data.targetLoadingDom){  // 显示loading的dom字符串
    TargetLoadingDom = document.querySelector(config.data.targetLoadingDom) ? config.data.targetLoadingDom: '.app-main';
    // console.error(TargetLoadingDom)
    delete config.data.targetLoadingDom;
  }
  if(config.data && config.data.useErrorMessage){ // 是否启用错误提示
    HasErrorMessage = config.data.useErrorMessage
    delete config.data.useErrorMessage;
  }
  if(config.url.indexOf('.json')>-1){
    NoLoading = true
  }
  // 判断是否是formData，是不显示loading
  const dataType = typeof config.data
  if(dataType === 'object'){
    let isFormData = (config.data instanceof FormData)
    if(isFormData){
      NoLoading = true
    }
  }
  Loadings = getCurrentLoading()
  if(!NoLoading){
    if(!Loadings){
      TargetLoadingDom = TargetLoadingDom || '.app-main-loading'
      // console.error(config.url,NoLoading,TargetLoadingDom,document.querySelector(TargetLoadingDom))
      Loadings = starLoading(TargetLoadingDom)
      // NoLoading = true
      // Loadings = Loading.service({
      //   target:TargetLoadingDom,
      //   lock: true,
      //   text: '加载中……',
      //   // spinner:'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // })
    }
  }
  if(configs.encryption) {
    config.method = 'post';
    if(config.responseType !== 'blob'){
        config.responseType = 'arraybuffer';
        config.headers['X-Agent-Type'] = 'json';
    }
    // UAT和本地调试用，勿删
    if(/^(uat|172)/.test(location.host)){
        console.log('=======' + config.url + '=======请求参数:');
        console.log(config.data);
    }
    //老接口处理
    if(whiteList.indexOf(config.url) >= 0){
      let wxdurl;
      const ISTEST = /^(uat|172\.18\.3)/.test(window.location.host);
        if (ISTEST) {
          wxdurl='https://uatserver.winhxd.com'
        } else {
          wxdurl='https://retail.winhxd.com'
        }
        config.url=wxdurl+config.url
        config.method = 'get';
        config.headers = { }
        flag=true
        config.params.info = encryptData(config.params.info||{})
    }else{
      config.data = encryptData(config.data||{})
    }

  }
  return config
}, error => {
  // Do something with request error
  console.log(error) // for debug
  Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
  response => {
    // @todo 处理 404等http 状态码
    // Message({
    //   message: response.data.message,
    //   type: 'success',
    //   duration: 5 * 1000
    // })
    // 导出时对返回数据不做处理
    CloseLoading(response.data)
    if (response.status === 201 || response.config.responseType === 'blob') {
      // CloseLoading()
      return response
    }
    let res = response.data

    if(configs.encryption) {
        Loadings.close()
        if(flag){
          res = decryptData(res,true) || {};
          flag=false
        }else{
          res = decryptData(res) || {};
        }
        // 将惠下单后台的成功请求后状态码subCode与bi,huistore的状态码code统一
        res.code = (res.subCode === 1 ? 0 : res.code);
        res.message = res.subMessage ? res.subMessage : res.message;
        // UAT和本地调试用，勿删
        if(/^(uat|172)/.test(location.host)){
            console.log('=======' + response.config.url + '=======返回数据:');
        }
    } else {
        // console.log(response)
    }
    if (res.code || res.code === 0) {
      if (res.code === 1002 && !configs.withoutLogin) {
        MessageBox.confirm('登录失效，请重新登录', '重新登录', {
          confirmButtonText: '重新登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            location.reload()
          })
        })
      } else {
        if(HasErrorMessage && res.code !==0){
          Message({
            message: res.message || '服务端错误：code+ 【'+res.code+ '】',
            type: 'error',
            duration: 5 * 1000
          })
        }
      }

      // CloseLoading()
      return res
    } else {
      Message({
        message: res.message,
        type: 'error',
        duration: 5 * 1000
      })
      // CloseLoading()
      return Promise.reject('error')
    }
  },
  error => {
    CloseLoading()
    console.log('err' + error)// for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js